import { useSelectedChain } from "@app/examples/ChainSelector"
import { PaginationBar } from "@components/PaginationBar"
import { CollectionCardV2 } from "@components/collection/CollectionCardV2"
import { useApi } from "@hooks/ApiHook"
import { UserResponse } from "baaanggg"
import React, { useState } from "react"

type Props = {
    user: UserResponse
}

export function MyCollectionTab({ user }: Props) {
    const [page, setPage] = useState(1)
    const { selectedChain } = useSelectedChain()
    const { data: paginatedCollection } = useApi(api => api.collection.all({ ownerAddress: user.walletAddress, page, chainId: selectedChain?.id }), [page, selectedChain])

    return <div>
        <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-3 lg:grid-cols-4 js-collections-grid">
            {
                paginatedCollection?.data.map(collection => {
                    return <CollectionCardV2 collection={collection} />
                })
            }
        </div>

        <div className="mt-5"></div>

        {
            paginatedCollection && <PaginationBar
                pagination={paginatedCollection}
                currentPage={page}
                onPageChange={page => setPage(page)} />
        }
    </div>
}